(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 40528:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(48454);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const statusMap = {
    success: "bg-green-400",
    error: "bg-rural-red-900 text-white",
    neutral: "bg-rural-gray-200"
};
function Badge(param) {
    let { children , status  } = param;
    const statusClass = statusMap[status];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "inline-block ml-2 text-xs uppercase font-semibold py-0.5 px-2 ".concat(statusClass),
        children: children
    });
}


/***/ }),

/***/ 67423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Breadcrumbs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



function Breadcrumbs(param) {
    let { links =[]  } = param;
    if (links.length === 0) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    const linkClass = "breadcrumb inline-block mr-2 font-semibold text-sm";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mb-10",
        children: links.map((link, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: link.href ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: link.href,
                    className: "".concat(linkClass, " text-rural-red-900"),
                    children: link.text
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "".concat(linkClass, " text-rural-gray-800"),
                    children: link.text
                })
            }, index))
    });
}


/***/ }),

/***/ 69149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11358);
/* harmony import */ var react_paginate__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_paginate__WEBPACK_IMPORTED_MODULE_2__);



function Pagination(param) {
    let { currentPage , onPageChange , pageSize , totalRecords  } = param;
    const pageCount = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return Math.ceil(totalRecords / pageSize);
    }, [
        pageSize,
        totalRecords
    ]);
    const buttonClass = "w-[35px] h-[35px] flex items-center justify-center text-sm border border-rural-gray-300 rounded-l-sm";
    const selectedClass = "bg-rural-red-900 text-white";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_paginate__WEBPACK_IMPORTED_MODULE_2___default()), {
            activeLinkClassName: selectedClass,
            containerClassName: "flex items-center text-rural-red-900",
            disabledLinkClassName: "text-rural-gray-400",
            forcePage: currentPage,
            nextLabel: "\xbb",
            nextLinkClassName: buttonClass,
            onPageChange: onPageChange,
            pageLinkClassName: "".concat(buttonClass, " border-r-0"),
            pageCount: pageCount,
            previousLabel: "\xab",
            previousLinkClassName: "".concat(buttonClass, " border-r-0"),
            breakClassName: "".concat(buttonClass, " border-r-0")
        })
    });
}


/***/ }),

/***/ 48454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Dashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-loading/dist/react-loading.js
var react_loading = __webpack_require__(733);
var react_loading_default = /*#__PURE__*/__webpack_require__.n(react_loading);
// EXTERNAL MODULE: ./components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(67423);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(92422);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/PredictiveSelect.tsx + 1 modules
var PredictiveSelect = __webpack_require__(62527);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 7 modules
var useQuery = __webpack_require__(20059);
// EXTERNAL MODULE: ./hooks/useFilters.tsx
var useFilters = __webpack_require__(37815);
// EXTERNAL MODULE: ./services/webservices/cpp.tsx
var cpp = __webpack_require__(95677);
;// CONCATENATED MODULE: ./hooks/useDashboard.tsx






const defaultResponse = {
    totalCount: 0,
    totalFilteredCount: 0,
    applications: []
};
const DashboardContext = /*#__PURE__*/ (0,react.createContext)(undefined);
function DashboardProvider(param) {
    let { children  } = param;
    const { filters , setFilters  } = (0,useFilters/* useFilters */.m)();
    const [pageSize, setPageSize] = (0,react.useState)(10);
    const [page, setPage] = (0,react.useState)(0);
    const [searchString, setSearchString] = (0,react.useState)("");
    const [sorting, setSorting] = (0,react.useState)([]);
    const { push  } = (0,router.useRouter)();
    (0,react.useEffect)(()=>{
        setPage(0);
    }, [
        pageSize,
        searchString,
        filters,
        sorting,
        setPage
    ]);
    const { isLoading , data  } = (0,useQuery/* useQuery */.a)([
        "dashboard",
        pageSize,
        page,
        filters,
        searchString,
        sorting
    ], ()=>(0,cpp/* getDashboard */.Ll)(pageSize * page, pageSize, filters, searchString, sorting).catch((error)=>{
            push("/401");
            console.error("There was an error ensuring agent principal details.", error);
        }), {
        enabled: filters !== undefined
    });
    const dashboardData = (0,react.useMemo)(()=>{
        return data || defaultResponse;
    }, [
        data,
        defaultResponse
    ]);
    const returnValue = (0,react.useMemo)(()=>({
            filters: filters || {},
            setFilters,
            pageSize,
            setPageSize,
            page,
            setPage,
            searchString,
            setSearchString,
            sorting,
            setSorting,
            dashboardData,
            isDashboardLoading: isLoading
        }), [
        filters,
        setFilters,
        pageSize,
        setPageSize,
        page,
        setPage,
        searchString,
        sorting,
        setSorting,
        dashboardData,
        isLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardContext.Provider, {
        value: returnValue,
        children: children
    });
}
function useDashboard() {
    const context = (0,react.useContext)(DashboardContext);
    if (context === undefined) {
        throw new Error("useDashboard must be used within a DashboardProvider");
    }
    return context;
}


;// CONCATENATED MODULE: ./components/FilterDrawer.tsx








const coverageTypes = [
    {
        value: "type1",
        label: "Type 1"
    },
    {
        value: "type2",
        label: "Type 2"
    },
    {
        value: "type3",
        label: "Type 3"
    }
];
const programCodes = [
    {
        value: "code1",
        label: "Code 1"
    },
    {
        value: "code2",
        label: "Code 2"
    },
    {
        value: "code3",
        label: "Code 3"
    }
];
function FilterCheckbox(param) {
    let { filterName , value , label  } = param;
    const { register  } = useFormContext();
    return /*#__PURE__*/ _jsx("div", {
        className: "mb-2",
        children: /*#__PURE__*/ _jsxs("label", {
            className: "inline-flex gap-x-2",
            children: [
                /*#__PURE__*/ _jsx("input", {
                    type: "checkbox",
                    value: value,
                    ...register(filterName, {
                        required: false
                    })
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "text-md font-thin",
                    children: label
                })
            ]
        })
    });
}
function FilterCategory(param) {
    let { children , filterKey , title  } = param;
    const { filters  } = useDashboard();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const toggleOpen = (0,react.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const filterValueString = (0,react.useMemo)(()=>{
        const filterValue = filters[filterKey];
        let returnString = "";
        if (Array.isArray(filterValue)) {
            returnString = filterValue.map((filter)=>{
                return filter.label || filter.value || filter;
            }).join(", ");
        }
        return returnString;
    }, [
        filterKey,
        filters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "border-b border-rural-gray-500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "flex justify-between items-center py-4 w-full",
                type: "button",
                onClick: ()=>toggleOpen(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "text-xl ".concat(filterValueString ? "font-bold" : "font-thin"),
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/arrow-right.svg",
                        width: 24,
                        height: 24,
                        alt: isOpen ? "Close" : "Open",
                        className: isOpen ? "rotate-90" : ""
                    })
                ]
            }),
            filterValueString && !isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8",
                children: filterValueString
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-8",
                children: children
            })
        ]
    });
}
function FilterDrawer(param) {
    let { onAccept =()=>{}  } = param;
    const { filters , setFilters  } = useDashboard();
    const { handleSubmit , reset  } = (0,index_esm/* useFormContext */.Gc)();
    const onSubmit = (data)=>{
        setFilters(data);
        onAccept();
    };
    const onClear = ()=>{
        setFilters({});
        reset();
        onAccept();
    };
    (0,react.useEffect)(()=>{
        reset(filters);
    }, [
        filters,
        reset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: "flex flex-1",
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mt-4 flex flex-1 flex-col border-t border-t-rural-gray-500",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                    title: "Agent",
                    filterKey: "agent",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictiveSelect/* default */.Z, {
                        name: "agent",
                        defaultValue: filters.agent,
                        noOptionsMessage: "No agents found",
                        placeholder: "Search by agent name...",
                        queryKey: "agents",
                        queryFunction: cpp/* getAgents */.j8
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterCategory, {
                    title: "Underwriter",
                    filterKey: "underwriter",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictiveSelect/* default */.Z, {
                        defaultValue: filters.underwriter,
                        name: "underwriter",
                        noOptionsMessage: "No underwriters found",
                        placeholder: "Search by underwriter name...",
                        queryFunction: cpp/* getUnderwriters */.ti,
                        queryKey: "underwriters"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-auto mb-8 flex gap-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "submit",
                            size: "large",
                            variant: "primary",
                            children: "Apply filters"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            type: "button",
                            size: "large",
                            variant: "border",
                            onClick: onClear,
                            children: "Reset"
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./hooks/useIsExporting.tsx
var useIsExporting = __webpack_require__(77166);
;// CONCATENATED MODULE: ./components/Filters.tsx








const Drawer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(483), __webpack_require__.e(893)]).then(__webpack_require__.bind(__webpack_require__, 5893)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(5893)
            ]
    },
    ssr: false
});
const filterKeyMap = {
    "underwriter": "Underwriter",
    "programCode": "Program Code",
    "coverage": "Coverage",
    "agent": "Agent"
};
function Tag(param) {
    let { filterKey , filterValue , onRemove =()=>{}  } = param;
    const labelString = (0,react.useMemo)(()=>{
        let filterValues = "";
        if (Array.isArray(filterValue)) {
            filterValues = filterValue.map((filter)=>{
                return filter.label || filter.value || filter;
            }).join(", ");
        }
        return filterValues;
    }, [
        filterValue
    ]);
    if (labelString === "") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "inline-flex items-center py-1 pl-4 text-sm font-bold",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "rounded-l-lg bg-rural-gray-300 py-1 pl-4 pr-2",
                children: [
                    filterKeyMap[filterKey],
                    ": ",
                    labelString
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "rounded-r-lg bg-rural-gray-300 py-1 px-3 hover:bg-rural-gray-500",
                onClick: ()=>onRemove(filterKey),
                children: "\xd7"
            })
        ]
    });
}
function Filters() {
    const { filters , setFilters  } = useDashboard();
    const [isFilterOpen, setIsFilterOpen] = (0,react.useState)(false);
    const toggleFilter = (0,react.useCallback)(()=>{
        setIsFilterOpen(!isFilterOpen);
    }, [
        isFilterOpen,
        setIsFilterOpen
    ]);
    const removeFilter = (0,react.useCallback)((filterKey)=>{
        const currentFilters = {
            ...filters
        };
        if (currentFilters[filterKey]) {
            delete currentFilters[filterKey];
        }
        setFilters(currentFilters);
    }, [
        filters,
        setFilters
    ]);
    const activeFilters = (0,react.useMemo)(()=>{
        return Object.entries(filters).filter((param)=>{
            let [, val] = param;
            return val !== undefined && (val === null || val === void 0 ? void 0 : val.length) > 0;
        });
    }, [
        filters
    ]);
    const methods = (0,index_esm/* useForm */.cI)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-2 flex-wrap items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        type: "button",
                        variant: "outline",
                        size: "medium",
                        onClick: ()=>{
                            toggleFilter();
                        },
                        children: "".concat(activeFilters.length > 0 ? "Update" : "Add", " filters")
                    }),
                    activeFilters.map((param)=>/*#__PURE__*/ {
                        let [key, val] = param;
                        return (0,jsx_runtime.jsx)(Tag, {
                            filterKey: key,
                            filterValue: val,
                            onRemove: removeFilter
                        }, key);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer, {
                isOpen: isFilterOpen,
                onClose: ()=>setIsFilterOpen(false),
                title: "Apply Filters",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useIsExporting/* IsExportingProvider */.W, {
                    isPdfExport: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer, {
                            onAccept: ()=>setIsFilterOpen(false)
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/Grid.tsx
var Grid = __webpack_require__(78659);
// EXTERNAL MODULE: ./components/Pagination.tsx
var Pagination = __webpack_require__(69149);
// EXTERNAL MODULE: ./components/Icon/index.ts + 4 modules
var Icon = __webpack_require__(43570);
;// CONCATENATED MODULE: ./components/Search.tsx




function Search(param) {
    let { searchStr , onCancel =()=>{} , onSubmit =()=>{}  } = param;
    const { handleSubmit , register , reset  } = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            recordSearch: searchStr
        }
    });
    const formCancel = (0,react.useCallback)(()=>{
        onCancel();
        reset();
    }, [
        onCancel,
        reset
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex w-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            id: "record-search",
                            type: "search",
                            placeholder: "Enter a client name, client number, or application ID...",
                            className: "border border-rural-gray-700 rounded-md p-3 w-full rounded-r-none",
                            ...register("recordSearch")
                        }),
                        searchStr && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "absolute right-4 top-[50%] -translate-y-[54%] text-rural-gray-600 font-bold text-2xl",
                            onClick: formCancel,
                            children: "\xd7"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    onClick: ()=>{},
                    className: "bg-rural-gray-100 border border-rural-gray-700 p-3 rounded-md rounded-l-none border-l-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        glyph: "search",
                        color: "#a4a4a4"
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/Table.tsx
var Table = __webpack_require__(12671);
// EXTERNAL MODULE: ./hooks/useMe.tsx
var useMe = __webpack_require__(24546);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(37490);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-table/build/umd/index.production.js
var index_production = __webpack_require__(24799);
// EXTERNAL MODULE: ./components/Badge.tsx
var Badge = __webpack_require__(73257);
// EXTERNAL MODULE: ./services/dates.ts
var dates = __webpack_require__(60511);
;// CONCATENATED MODULE: ./definitions/dashboardTable.tsx





const columnHelper = (0,index_production.createColumnHelper)();
const dashboardColumns = [
    columnHelper.accessor((row)=>row.displayId ? row.displayId : row.id, {
        id: "id",
        cell: (info)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/cpp/?cppId=".concat(info.row.original.id),
                        className: "font-bold text-rural-red-900",
                        children: info.getValue()
                    }),
                    info.row.original.isMidterm && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        status: "neutral",
                        children: "Amend"
                    }),
                    info.row.original.inactive && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                        status: "neutral",
                        children: "Inactive"
                    })
                ]
            }),
        header: ()=>"Application ID",
        enableSorting: true
    }),
    columnHelper.accessor("clientName", {
        cell: (info)=>info.getValue(),
        header: ()=>"Client name",
        enableSorting: true
    }),
    columnHelper.accessor("clientGuid", {
        cell: (info)=>info.getValue(),
        header: ()=>"Client number",
        enableSorting: true
    }),
    // columnHelper.accessor( 'quoteNumber', {
    // 	cell: info => info.getValue(),
    // 	header: () => 'Quote number'
    // }),
    columnHelper.accessor("lastModified", {
        cell: (info)=>(0,dates/* formatDateTimeInCst */.eY)(info.getValue()),
        header: ()=>"Last modified",
        enableSorting: true
    }),
    columnHelper.accessor("quoteEffectiveDate", {
        cell: (info)=>(0,dates/* formatDate */.p6)(info.getValue()),
        header: ()=>"Effective date",
        enableSorting: true
    }),
    columnHelper.accessor("agent", {
        cell: (info)=>info.getValue(),
        header: ()=>"Agent",
        enableSorting: true
    }),
    columnHelper.display({
        id: "actions",
        cell: (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/cpp/?cppId=".concat(props.row.original.id),
                className: "text-rural-red-900",
                children: props.row.original.inactive ? "View" : "Manage"
            })
    })
];


// EXTERNAL MODULE: ./definitions/userRoles.ts
var userRoles = __webpack_require__(91578);
;// CONCATENATED MODULE: ./pages/dashboard.tsx


















function DashboardTable() {
    const { isConfirmed  } = (0,useModal/* useModal */.d)();
    const { isLoggedIn , subAgentNumber , role  } = (0,useMe/* useMe */.Pi)();
    const { push  } = (0,router.useRouter)();
    const createCppConfirm = (0,react.useCallback)(async (agentData, effectiveDate, isMidterm)=>{
        let agentValue = agentData;
        if (!agentValue) {
            agentValue = {
                agentId: subAgentNumber
            };
        }
        try {
            const createRequest = await (0,cpp/* createCpp */.A6)(agentValue, isMidterm, effectiveDate);
            if (createRequest.id) {
                let applicationId;
                const cppDetails = await (0,cpp/* getCpp */.yk)(createRequest.id);
                if (cppDetails.applications) {
                    applicationId = cppDetails.applications[0].id;
                }
                if (applicationId) {
                    push("/cpp/form/?cppId=".concat(createRequest.id, "&formId=").concat(applicationId, "&isNew=true"));
                } else {
                    push("/cpp/?cppId=".concat(createRequest.id));
                }
            }
        } catch (e) {
            throw new Error("Error saving the application");
        }
    }, [
        push,
        subAgentNumber
    ]);
    const createCppClick = (0,react.useCallback)(async (isMidterm)=>{
        await isConfirmed({
            type: "createcpp",
            onConfirm: createCppConfirm,
            isMidterm
        });
    }, [
        createCppConfirm,
        isConfirmed
    ]);
    const { filters , page , pageSize , setPage , setPageSize , searchString , setSearchString , sorting , setSorting , dashboardData , isDashboardLoading  } = useDashboard();
    const handlePageChange = (event)=>{
        setPage(event.selected);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Application Dashboard | Rural Mutual Insurance Company"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex gap-x-8 items-center mb-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-auto max-w-[65%]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                            searchStr: searchString,
                            onSubmit: (data)=>setSearchString(data.recordSearch),
                            onCancel: ()=>setSearchString("")
                        })
                    }),
                    isLoggedIn && (0,userRoles/* isCreateCppAllowed */.Mc)(role) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-x-8 ml-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "primary",
                                size: "large",
                                onClick: ()=>createCppClick(false),
                                children: "Create new CPP"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "outline",
                                size: "large",
                                onClick: ()=>createCppClick(true),
                                children: "Amend Existing CPP"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                className: "mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                    columns: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    isDashboardLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute -top-2 -bottom-2 -right-2 -left-2 flex items-center justify-center bg-slate-200/80",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((react_loading_default()), {
                            type: "spin",
                            color: "#676767",
                            width: 64,
                            height: 64
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                            columns: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "font-bold text-rural-gray-800",
                                children: [
                                    dashboardData.totalCount,
                                    " record",
                                    "".concat(dashboardData.totalCount === 1 ? "" : "s"),
                                    searchString && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " match",
                                            "".concat(dashboardData.totalCount === 1 ? "es" : ""),
                                            " ",
                                            '"'.concat(searchString, '"')
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Table/* default */.Z, {
                        data: dashboardData.applications,
                        columns: dashboardColumns,
                        sorting: sorting,
                        setSorting: setSorting
                    }),
                    dashboardData.totalCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                columns: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                            id: "records-per-page",
                                            className: "border border-rural-gray-300 bg-white py-1 px-2 rounded-sm",
                                            defaultValue: pageSize,
                                            onChange: (event)=>{
                                                setPageSize(event.target.value);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "10"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "15"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "20"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    children: "50"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm font-thin",
                                            children: "per page"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Column */.s, {
                                columns: 6,
                                className: "ml-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                    currentPage: page,
                                    onPageChange: handlePageChange,
                                    pageSize: pageSize,
                                    totalRecords: dashboardData.totalCount
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function Dashboard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                links: [
                    {
                        text: "Dashboard"
                    }
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardProvider, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardTable, {})
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [358,675,774,888,179], function() { return __webpack_exec__(40528); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);